import { UseRenderLogging } from '@actr/widgets/src/hooks/use-render-logging';
import { useInitAppLogs } from 'Logs/app';
import { observer } from 'mobx-react-lite';
import type { FC, ReactNode } from 'react';
import React from 'react';

/** HOC для кода, который должен выполняться после инициализации провайдеров проложения */
const ContentWrapper: FC<{ children: ReactNode }> = props => {
  const { children } = props;

  useInitAppLogs();
  UseRenderLogging();

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {children}
    </>
  );
};

export default observer(ContentWrapper);
